type Data = {
  key: string | number;
  count: number;
};

export const convertToNivoData = (data: Data[] | undefined | null, id: string = "id") => {
  return [
    {
      id,
      data: data ? data.map((day) => ({ x: day.key, y: day.count })) : [],
    },
  ];
};
